<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :gutter="40">
          <a-col :span="24" class="gutter-row">
            <h2>Change Password</h2>
          </a-col>
        </a-row>
        <a-row :gutter="40">
          <a-col
            :xs="{ span : 24 }"
            :md="{ span : 12 }"
            style="margin-bottom: 10px;"
            class="gutter-row"
          >
            <a-card class="Custom--Card">
              <a-form layout="horizontal">
                <a-form-item
                  label="Current Password"
                  :label-col="{ xs: { span: 24 }, sm: { span: 7 } }"
                  :wrapper-col="{ xs: { span: 24 }, sm: { span: 16 } }"
                  :validate-status="errors.hasOwnProperty('password_current') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('password_current') ? errors.password_current[0] : ''"
                >
                  <a-input placeholder="Enter current login password" v-model="form.password_current" type="password" />
                </a-form-item>
                <a-form-item
                  label="New Password"
                  :label-col="{ xs: { span: 24 }, sm: { span: 7 } }"
                  :wrapper-col="{ xs: { span: 24 }, sm: { span: 16 } }"
                  :validate-status="errors.hasOwnProperty('password') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('password') ? errors.password[0] : ''"
                >
                  <a-input placeholder="Enter new password" v-model="form.password" type="password" />
                </a-form-item>
                <a-form-item
                  label="Confirm Password"
                  :label-col="{ xs: { span: 24 }, sm: { span: 7 } }"
                  :wrapper-col="{ xs: { span: 24 }, sm: { span: 16 } }"
                  :validate-status="errors.hasOwnProperty('password_confirmation') ? 'error' : 'validating'"
                  :help="errors.hasOwnProperty('password_confirmation') ? errors.password_confirmation[0] : ''"
                >
                  <a-input placeholder="Enter confirm password" v-model="form.password_confirmation" type="password" />
                </a-form-item>
                <a-form-item
                  :wrapper-col="{ span: 14, offset: 7 }"
                >
                  <a-button type="primary" @click.prevent="changePassword" :loading="loading">
                    Change Password
                  </a-button>
                </a-form-item>
              </a-form>
            </a-card>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
  import Sidebar from '@/components/Sidebar.vue';
  export default {
    components: { Sidebar },
    data() {
      return {
        form: {
          password_current: '',
          password: '',
          password_confirmation: '',
        },
        loading: false,
        errors: {}
      }
    },
    methods: {
      changePassword() {
        this.loading = true;
        this.errors = {};
        this.$store.dispatch('profile/CHANGE_PASSWORD', this.form)
            .then(response => {
              if (response.success) {
                this.form.password_current = '';
                this.form.password = '';
                this.form.password_confirmation = '';
                this.errors = {};
                this.$weNotify("success", "Login password changed!");
              }
            })
            .catch(error => {
              this.errors = error.data.errors;
            });
        this.loading = false;
      }
    }
  }
</script>